import { TConciergeData } from '@/types/responses/common';

export class Concierge {
  value: number;
  text: string;
  isDeleted: boolean;

  constructor(conciergePulldownData: TConciergeData) {
    this.text = conciergePulldownData.name;
    this.value = conciergePulldownData.conciergeId;
    this.isDeleted = conciergePulldownData.isDeleted;
  }
}
